import { ClientLabel } from 'labels/client'
import { cx } from 'utils/cx'

import styles from './SelectMessage.module.scss'
import texts from 'fukku/styles/texts.module.scss'

interface SelectMessageProps {
	readonly id: string
	readonly hintMessage?: string
	readonly errorMessage?: string
	readonly hintPlaceholders?: Record<string, string | number>
	readonly errorPlaceholders?: Record<string, string | number>
	readonly showHint: boolean
}

export function SelectMessage({
	id,
	hintMessage,
	errorMessage,
	hintPlaceholders,
	errorPlaceholders,
	showHint,
}: SelectMessageProps): React.ReactNode {
	return (
		<>
			{hintMessage && (
				<p
					className={cx(
						texts.bodyS,
						styles.hint,
						showHint && !errorMessage && styles.showHint
					)}
					id={`${id}-hint`}
				>
					<ClientLabel placeholderValues={hintPlaceholders}>
						{hintMessage}
					</ClientLabel>
				</p>
			)}
			{errorMessage && (
				<p
					className={cx(
						texts.bodyS,
						styles.error,
						errorMessage && styles.showError
					)}
					id={`${id}-error`}
				>
					<ClientLabel placeholderValues={errorPlaceholders}>
						{errorMessage}
					</ClientLabel>
				</p>
			)}
		</>
	)
}
